(() => {
  if (customElements.get('sv-product-information')) return;
  class ProductInformation extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animations = new Map();
      this.querySelectorAll('.sv-information-content .metafield-rich_text_field').forEach(content => {
        const hasHeadings = Boolean(content.querySelector(':scope > :is(h2,h3,h4,h5,h6)'));
        if (!hasHeadings && !content.closest('[data-sv-product-description="native"]')) return;
        Array.from(content.children).forEach(block => {
          if (!block.matches('p')) return;
          const text = block.textContent.trim();
          const inlineOnly = Array.from(block.querySelectorAll('*')).every(node =>
            node.matches('br,strong,b,em,i,span')
          );
          if (!text && inlineOnly) {
            block.classList.add('sv-information-spacer');
            return;
          }
          const bold = Array.from(block.querySelectorAll(':scope > strong, :scope > b'));
          if (text && bold.length && inlineOnly &&
              Array.from(block.childNodes).every(node =>
                node.nodeType === Node.TEXT_NODE ? !node.textContent.trim() :
                  node.nodeType === Node.ELEMENT_NODE && node.matches('strong,b')
              )) {
            block.classList.add('sv-information-subheading');
          }
        });
        if (hasHeadings || content.querySelector(':scope > .sv-information-subheading')) {
          content.classList.add('sv-information-normalized');
        }
      });
      this.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (!summary || summary.closest('sv-product-information') !== this) return;
        event.preventDefault();
        const section = summary.parentElement;
        const nextOpen = !(this.animations.get(section)?.opening ?? section.open);
        if (nextOpen && this.dataset.multiOpen !== 'true') {
          this.querySelectorAll(':scope > details[open]').forEach(other => {
            if (other !== section) this.setOpen(other, false);
          });
        }
        this.setOpen(section, nextOpen);
      });
    }
    setOpen(section, opening) {
      const panel = section.querySelector('.sv-information-panel');
      const startHeight = section.open ? panel.getBoundingClientRect().height : 0;
      this.animations.get(section)?.animation.cancel();
      this.animations.delete(section);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !panel.animate) {
        panel.style.overflow = '';
        section.open = opening;
        return;
      }
      section.open = true;
      const endHeight = opening ? panel.scrollHeight : 0;
      panel.style.overflow = 'hidden';
      const animation = panel.animate(
        [{height: `${startHeight}px`}, {height: `${endHeight}px`}],
        {duration: 400, easing: 'ease-in-out'}
      );
      this.animations.set(section, {animation, opening});
      animation.onfinish = () => {
        section.open = opening;
        panel.style.overflow = '';
        this.animations.delete(section);
      };
    }
    disconnectedCallback() {
      this.animations?.forEach(({animation}) => animation.cancel());
    }
  }
  customElements.define('sv-product-information', ProductInformation);
})();
